import React, { useEffect, useState } from "react";
import FacebookLogin, { FacebookLoginClient } from '@greatsumini/react-facebook-login';
import { FACEBOOK_APP_ID } from "../constants";
import { useUser } from "../hooks/useApi";
import useLanguage, { T } from "../hooks/useLanguage";
import Button from "./basic/Button";
import Loader from "./basic/Loader";
import { prepareEntryIntentForCurrentLocation } from "../features/entryFlow/entryIntentStorage";

export default function FacebookButton({ enabled = true }) {
  const { i18n } = useLanguage();
  const { login, mutation } = useUser();

  const [errorMessage, setErrorMessage] = useState("");

  /**
   * @param {*} loginResponse
   * @property {string} accessToken - The user's Facebook access token
   */
  const responseFacebook = async (loginResponse) => {
    console.log("Facebook login response", loginResponse);

    // Token puede venir en res.accessToken o res.authResponse.accessToken
    const accessToken =
      loginResponse?.accessToken ?? loginResponse?.authResponse?.accessToken;

    if (!accessToken) {
      setErrorMessage(i18n.t("home.facebookerror"));
      return;
    }

    if (loginResponse && loginResponse.hasOwnProperty("accessToken")) {
      FacebookLoginClient.getProfile((profileResponse) => {
        let email = profileResponse.email;
        if (!email && profileResponse.hasOwnProperty("id")) {
          email = `${profileResponse.id}@facebook.com`;
        }
        if (email !== undefined) {
          const dataToSend = {
            email: email,
            oauthid:
              profileResponse.id ??
              loginResponse?.userID ??
              loginResponse?.authResponse?.userID,
            name: profileResponse.name,
            oauth: accessToken,
            picture: profileResponse?.picture?.data?.url,
            type: "facebook",
          };
          login(dataToSend);
        } else {
          console.log("setErrorMessage");
          setErrorMessage(i18n.t("home.facebookerror"));
        }
      });
    } else {
      console.log("setErrorMessage");
      setErrorMessage(i18n.t("home.facebookerror"));
    }
  };

  useEffect(() => {
    console.log("errorMessage sideEffects", errorMessage);
    if (errorMessage !== "") {
      setTimeout(() => {
        setErrorMessage("");
      }, 3500);
    }
  }, [errorMessage]);

  return (
    <FacebookLogin
      appId={FACEBOOK_APP_ID}
      autoload="false"
      scope="public_profile,email"
      fields="id,name,email,picture{url,height,width,is_silhouette}"
      onSuccess={(response) => responseFacebook(response)}
      onFail={() => setErrorMessage(i18n.t("home.facebookerror"))}
      render={(renderProps) => (
        <div>
          <Button
            onClick={(event) => {
              prepareEntryIntentForCurrentLocation();
              renderProps.onClick(event);
            }}
            className="facebook"
            disabled={renderProps.disabled || !enabled}
            // prevents an existing Facebook session from logging users in automatically
            autoload="false"
          >
            <div>
              {mutation?.isLoading ? <Loader /> : <T>home.loginfacebook</T>}
            </div>
          </Button>
          {errorMessage !== "" ? (
            <div className="facebook-error-msg">{errorMessage}</div>
          ) : null}
        </div>
      )}
      className="facebook"
      redirectUri="https://millsonicbox.com/"
      disableMobileRedirect={true}
      authType="rerequest"
    />
  );
}

/**
 *
 * code=AQAXGNW5xko8Q_Nto8BEMlYWIDgKZQSWiu4VyPqb-ApSX9KieU86bW4-F3HuqyeTBzxJPi1dcI8jNqhfL6492KjLv5pQJBZyISGLptYUUS0W5pV6gn_3YHN_AKraQzlZQnuxZivF3lr9k623XnWXkEQOgdYgngs3a9hp6_pxXBUbYrBNJlvze6b3nFUcXaOrI91DvI_TVnZ9x5BLwTKk1vaTPrLjmRUW1yNPyI3PM8Gdo-cjYX9N43VvIDReKTouSyMiLjfOMITaPEyp3tICjboHNy6lE6-I0CRpc5MxRVim5ljr_x6Y9V2eMLHJw_7uZNgzwyEoCOFmZjombz53pDVwoGmtL-WPz4ScPAlUS71zNp1gUXWpgE-b6aQDPHS_sMw
 * state=facebookdirect#_=_
 */

/**
 * accessToken: "aZ09..."
 * data_access_expiration_time: 1645973663
 * email: "...@...mail.com"
 * expiresIn: 3936
 * graphDomain: "facebook"
 * id: "10221731574659771"
 * name: "John Doe"
 * picture: {data: {
 *  height: 50,
 *  width: 50,
 *  is_silhouette: false,
 *  url: "https://platform-lookaside.fbsbx.com/..."
 * }}
 * signedRequest: "aZ09..."
 * userID: "10221731574659771"
 */
